import styled, { css } from 'styled-components'

import { Colors, mediaQueries } from '@fourthwall/components'

export const Container = styled.div`
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: var(--space-300);

  ${mediaQueries.tablet} {
    grid-template-columns: repeat(3, 1fr);
  }
`

export const Button = styled.button<{ active?: boolean }>`
  display: flex;

  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: var(--space-300);
  flex-direction: row;

  padding: var(--space-400);

  color: var(--text-secondary);
  font-size: var(--font-size-400);
  line-height: var(--font-line-height-400);
  letter-spacing: var(--font-letter-spacing-normal);

  border: 1px solid var(--border-primary);
  border-radius: var(--radius-brand);

  &:hover {
    border-color: var(--border-primary-hover);
  }

  &:disabled {
    color: ${Colors.GS500};
    cursor: not-allowed;
  }

  ${({ active }) =>
    active &&
    css`
      color: var(--text-primary);
      border: 1px solid var(--border-active);
    `};
`
